export enum UserTypes {
  Admin = "Admin",
  Customer = "Customer",
}
